import { AxiosError } from 'axios';

interface ErrorResponse {
  readonly code: number;
  readonly message: string;
}

export interface ApiErrorModel {
  readonly status: number;
  readonly message: string;
}

export function apiErrorHandler(error: AxiosError<ErrorResponse>) : Promise<ApiErrorModel> {
  const { response } = error;

  if (response !== undefined) {
    // handle server-side error
    const { status, data } = response;

    if (typeof data === 'string') {
      // non-standart error
      return Promise.reject<ApiErrorModel>({
        status,
        message: data
      });
    } else {
      // standart error
      return Promise.reject<ApiErrorModel>({
        status,
        message: data.message
      });
    }
  } else {
    // handle client-side errors
    return Promise.reject<ApiErrorModel>({
      message: error.message,
      status: 0
    });
  }
}
